export const demoData = [
  `## TCMS 보드 교체 시 필요 공구 및 작업 절차

TCMS(Train Control & Monitoring System) 보드 교체 과정에서 사용되는 공구와 그에 따른 주요 작업 절차는 다음과 같습니다.

| 공구명             | 작업 절차             |
|--------------------|-----------------------|
| (+), (−) 드라이버  | 취거 작업, 조립       |
| 스패너             | 검사                  |
| 육각렌치           | 취거 작업             |
| 소켓렌치           | 검사                  |
| 라쳇핸들           | 검사                  |
| 브러시             | 세척 작업             |
| 납땜기             | 정비                  |
| 핀셋               | 정비                  |

---

### 안내 사항
- 상기 공구들은 TCMS 보드의 **탈거, 장착, 검사, 세척 및 정비** 전반에 사용됩니다.  
- 실제 교체 작업 전, 각 공구의 이상 여부를 확인하는 것이 권장됩니다.  
- 현장 환경 및 보드 상태에 따라 **추가적인 특수 장비**가 필요할 수 있습니다.`,
  `## TCMS 보드 교체 시 필요 공구 이미지 안내

요청하신 내용에 따라, TCMS(Train Control & Monitoring System) 보드 교체 작업에 필요한 주요 공구들의 이미지를 정리하였습니다.  
아래 표는 각 공구를 시각적으로 확인할 수 있도록 준비된 자료입니다.  

| 공구명             | 이미지 |
|--------------------|--------|
| (+), (−) 드라이버 | ![드라이버 이미지](/assets/images/screwdriver.png) |
| 스패너             | ![스패너 이미지](/assets/images/spanner.png) |
| 육각렌치           | ![육각렌치 이미지](/assets/images/hexwrench.png) |
| 소켓렌치           | ![소켓렌치 이미지](/assets/images/socketwrench.png) |
| 라쳇핸들           | ![라쳇핸들 이미지](/assets/images/ratchet.png) |
| 브러시             | ![브러시 이미지](/assets/images/brush.png) |
| 납땜기             | ![납땜기 이미지](/assets/images/solderingmachine.png) |
| 핀셋               | ![핀셋 이미지](/assets/images/tweezers.png) |
`,
];
